import React from "react";

// The teleprompter over the frame, while the camera is on: the template's
// script rolls up past the marks at its middle, wrapping where the screen is
// narrow, and starts over. Two copies roll as one, so it loops without a
// jump; another template's script starts again from its first line, the
// screen staying where it is. The visitor reads it; it never shows in the
// video.
export default function PrompterStrip({ lines }) {
  return (
    <div className="st-pr" style={{ "--lines": lines.length }} aria-hidden="true">
      <div className="st-pr-run" key={lines.join("\n")}>
        {[0, 1].map((copy) => (
          <p key={copy}>
            {lines.map((line, i) => <span key={i}>{line}</span>)}
          </p>
        ))}
      </div>
    </div>
  );
}
